import axiosInstance from "./axios";
import { useState, useEffect } from "react";
import { setUser, setLogo } from "../Redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import useFetchMedia from "./useGetMedia";

const useAuth = (token) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { fetchMedia } = useFetchMedia();
  const url = "/manager/auth";

  const setUserData = (data) => {
    dispatch(setUser(data));
  };

  const checkToken = async () => {
    setLoading(true);
    axiosInstance
      .get(url)
      .then((response) => {
        setUserData(response.data);
        localStorage.setItem("Manager-token", response.data.token);
        sessionStorage.setItem("Manager-token", response.data.token);
        setLoading(false);
        return response.data;
      })
      .then((data) => {
        if (data?.school?.logoUrl) {
          fetchMedia(data?.school?.logoUrl).then((response) => {
            dispatch(setLogo(response));
          });
        }
      })
      .catch((error) => {
        sessionStorage.removeItem("Manager-token");
        localStorage.removeItem("Manager-token");
        setError(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (token && !user.isLogged && !loading) {
      localStorage.setItem("Manager-token", token);
      checkToken();
    } else {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, dispatch, user.isLogged]);

  return { loading, error };
};
export default useAuth;
